<app-loading></app-loading>
<app-pwa-install-banner></app-pwa-install-banner>
<app-pwa-status></app-pwa-status>
<router-outlet></router-outlet>